<template>
    <section id="rates" class="rates section">
        <div class="container_big">
            <div class="rates__title">
                <app-title>ТАРИФЫ</app-title>
            </div>
            <div class="rates__inner">
                <div class="rates__items">
                    <template v-for="item in rates">
                        <RateItemVue :item="item"/>
                    </template>
                </div>
                <div class="rates__contact">
                    <span>Для оплаты связаться</span>
                    <a href="https://t.me/cheersgyu" target="_blank" class="rates__contact-link">
                        <img src="@/assets/img/tg_icon.svg" alt="Telegram">
                    </a>
                    <a href="https://www.instagram.com/you.course/" target="_blank" class="rates__contact-link">
                        <img src="@/assets/img/inst_icon.svg" alt="Instagram">
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import RateItemVue from "@/components/mainPage/RateItemVue";

export default {
    name: "rates",
    components: {RateItemVue},
    data() {
        return {
            rates: [
                {
                    name: 'Консультация',
                    times: 'Единоразово',
                    list: {
                        name: 'Вы пишите мне, например:',
                        items: [
                            'С чего начать похудение?',
                            'Сколько раз в неделю мне стоит тренироваться?',
                            'Как научиться считать калории?'
                        ]
                    },
                    descr: [
                        'Через сутки я с вами свяжусь по видео, ауидозвонку или в сообщениях.',
                        'На консультации я разберу ваш вопрос и любые дополнительные.'
                    ],
                    price: {
                        price: '1000₽',
                        again: 'повторно 800₽'
                    }
                },
                {
                    name: 'Тренировочный план',
                    times: 'Единоразово',
                    list: {
                        name: 'В сообщении вы указываете некоторые детали:',
                        items: [
                            'Где вы занимаетесь (дом или тренажёрный зал)',
                            'Инвентарь, который имеете (гантели, резинки, коврик, штанга и т. д.)',
                            'Ваши особенности (например, есть проблемы со здоровьем)',
                            'Наличие свободного времени (можете заниматься только 3 раза в неделю и т. д.)',
                        ]
                    },
                    descr: [
                        'В течение 2-х дней я составлю для вас программу и подкорректирую, если это потребуется.',
                    ],
                    price: {
                        price: '1000₽',
                        again: 'повторно 800₽'
                    }
                },
                {
                    name: 'Сопровождение',
                    times: 'Длится 21 день',
                    supDescr: 'Вы проходите вводное анкетирование.',
                    list: {
                        name: 'И после получаете:',
                        items: [
                            'Рекомендации по ведению рациона',
                            'Доступ к тренировкам',
                            'Трекер для отслеживания параметров тела',
                            'Методичку с главными темами по достижению цели',
                            'Планер и дневник вашего здоровья',
                        ]
                    },
                    descr: [
                        'Куратор будет сопровождать вас на всех этапах, и отвечать на любые вопросы.',
                    ],
                    price: {
                        price: '3000₽',
                        again: 'повторно 2800₽'
                    }
                },
                {
                    name: 'Сопровождение парное',
                    times: 'Длится 21 день',
                    descr: [
                        'Тот же тариф «Сопровождение» только для двух человек.',
                        'Подходит для подруг, сестёр, матери и дочери.'
                    ],
                    price: {
                        price: '4000₽',
                        again: 'повторно 3800₽'
                    }
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.rates {
    text-align: center;

    &__contact {
        display: flex;
        justify-content: center;
        margin-top: 48px;
        gap: 5px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 120%;
        color: rgba(83, 67, 64, 0.6);
        @media (max-width: 767px) {
            margin-top: 40px;
        }
        @media (max-width: 479px) {
            font-size: 16px;
        }
    }

    &__contact-link {
        width: 26px;
        height: 26px;
        display: block;

        & img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        @media (max-width: 479px) {
            width: 16px;
            height: 16px;
        }
    }

    &__title {
        text-align: center;
        display: inline-block;
        margin: -40px auto 0;
    }

    &__inner {
        border: 1.5px solid #CDCDCD;
        border-radius: 40px;
        margin-top: -55px;
        padding: 107px 104px 150px;
        @media (max-width: 1919px) {
            padding: 86px 10px 150px;
        }
        @media (max-width: 1439px) {
            border: none;
            padding: 105px 0 136px;
        }
        @media (max-width: 767px) {
            padding-top: 85px;
        }
        @media (max-width: 479px) {
            padding-top: 65px;
        }
    }

    &__items {
        display: flex;
        justify-content: space-between;
        @media (max-width: 1439px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, 1fr);
            gap: 20px;
            justify-content: center;
            align-items: center;
            height: max-content;
        }
        @media (max-width: 767px) {
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
        }
    }
}
</style>